import axios from 'axios';
import { dataTypeEnum, getData } from 'utils';

async function createProvider() {
  const user = getData(dataTypeEnum.userData)
  const company = getData(dataTypeEnum.companyData)
  const place = getData(dataTypeEnum.placeData)

  let formData = new FormData();
  formData.append("firstName", user.firstName);
  formData.append("lastName", user.lastName);
  formData.append("email", user.email);
  formData.append("phone", user.phone);
  formData.append("socialName", company.companySocialReason);
  formData.append("address_name", company.address_name);
  formData.append("index", company.index ?? '');
  formData.append("way_type", company.way_type);
  formData.append("street_number", company.street_number);
  formData.append("companyCity", company.companyCity);
  formData.append("companyPostalCode", company.companyPostalCode);
  formData.append("siren", company.companySiren);
  formData.append("companyCategory", company.companyCategory);
  formData.append("companySubcategory", company.companySubcategory);
  formData.append("companyActivity", company.companyActivity);
  formData.append("nafCode", company.nafCode);
  formData.append("legal_status", company.legal_status);
  formData.append("placeAddress", place.placeAddress);
  formData.append("placeZipCode", place.placeZipCode);
  formData.append("placeCity", place.placeCity);
  formData.append("companyExternalRatingURL", company.companyExternalRatingURL);

  const response = await axios.post('/providers', formData);

  return response.data;
}

async function editProvider(data) {
  const response = await axios.put('/provider', data);

  return response.data;
}

async function getClients() {
  const response = await axios.get(`/provider/clients`);

  return response.data;
}

async function getCurrentProvider() {
  const response = await axios.get('/provider');

  return response.data;
}

async function getPicture() {
  const response = await axios.get('/provider/images');

  return response.data;
}

async function isRegistered(email) {
  const response = await axios.get(`/providers/registered?email=${email}`);

  return response.data;
}

async function sendUpdatePasswordEmail(data) {
  const response = await axios.put('/providers/password', data);

  return response.data;
}

async function updatePicture(data) {
  const response = await axios.post('/provider/images', data);

  return response.data;
}

async function updateProvider(data) {
  const response = await axios.put('/provider', data);

  return response.data;
}

const providerService = {
  createProvider,
  editProvider,
  getClients,
  getCurrentProvider,
  getPicture,
  isRegistered,
  sendUpdatePasswordEmail,
  updatePicture,
  updateProvider,
}

export default providerService;
